import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 15l6 -6","key":"svg-1"}],["path",{"d":"M11 9h4v4","key":"svg-2"}]]

const IconOutbound = createReactComponent('outline', 'outbound', 'Outbound', __iconNode);

export default IconOutbound;